import myPic from "./assets/images/my-pic.jpg";

const logotext = "HAMZA.Z";
const meta = {
    title: "Hamza Zahid",
    description:
        "Hamza Zahid | Freelance Video Editor on Fiverr, specializing in YouTube videos, Reels, Shorts, and social media content",
};

const introdata = {
    title: "I’m Hamza Zahid",
    // roles cycle in the hero typewriter
    roles: [
        "Video Editor",
        "Short-Form Video Editor",
        "Social Media Video Editor",
        "Visual Storyteller",
    ],
    description:
        "I’m a video editor who turns raw footage into clear, engaging stories. From social media clips to polished edits, I focus on pacing, clean transitions, and visuals that keep viewers watching.",
    your_img_url: myPic,
    // quick creative badges shown under the hero
    stack: [
        "Video Editing",
        "Short-Form Content",
        "Social Media Videos",
        "Storytelling",
        "Color Grading",
        "Sound Design",
    ],
};

const dataabout = {
    title: "A bit about myself",
    aboutme:
        "I’m a creative, detail-oriented video editor with 2+ years of experience creating content for software, e-commerce, YouTube, and social media. I edit videos, vlogs, Reels, Shorts, and promotions using Adobe Premiere Pro, After Effects, CapCut, Filmora, Camtasia, Lightroom, and FFmpeg, with skills in pacing, sound, transitions, and color grading. I also use AI-assisted tools to shape engaging content for each audience.",
};

// quick stats shown on the About page
const aboutstats = [
    { label: "Years of Video Editing Experience", value: "2+" },
    { label: "Video Formats Edited", value: "5+" },
    { label: "Editing Tools", value: "7+" },
    { label: "AI-Assisted Editing", value: "Experienced" },
];

const worktimeline = [{
        jobtitle: "Freelance Video Editor",
        where: "Fiverr",
        date: "December 2024 - Present",
    },
    {
        jobtitle: "Motion Graphics Designer",
        where: "Bold Stream Production",
        date: "January 2023 - December 2024",
    },
    {
        jobtitle: "Social Media Video Editor",
        where: "Cineviz Studio",
        date: "April 2023 - September 2023",
    },
];

const skills = [
    { name: "Storytelling, pacing & narrative flow", value: 92 },
    { name: "Cutting, trimming & seamless transitions", value: 92 },
    { name: "Editing to music, rhythm & beat sync", value: 90 },
    { name: "Audio editing, sound selection & mixing", value: 88 },
    { name: "Color correction & color grading", value: 86 },
    { name: "Motion graphics, titles & text animation", value: 84 },
    { name: "Layouts, framing & visual composition", value: 88 },
    { name: "Editing for YouTube, Reels & Shorts", value: 92 },
    { name: "Product, promotional & social content", value: 90 },
    { name: "AI-assisted video creation & editing", value: 85 },
    { name: "FFmpeg video processing", value: 80 },
];

const services = [
    {
        title: "YouTube Video Editing",
        description:
            "Turn your raw footage into polished YouTube videos with clear storytelling, clean cuts, smooth pacing, music, sound cleanup, color correction, and engaging titles. Ideal for talking-head videos, tutorials, reviews, and channel content.",
    },
    {
        title: "Reels, Shorts & TikTok Videos",
        description:
            "Short-form edits designed for social platforms, with strong opening hooks, tight cuts, captions, on-screen graphics, music synced to the action, and vertical formatting for Reels, Shorts, and TikTok.",
    },
    {
        title: "Vlog Editing",
        description:
            "Shape your vlog footage into an enjoyable story. I select the best moments, improve pacing, add music and natural sound, and use transitions, titles, and color adjustments to keep the video feeling cohesive.",
    },
    {
        title: "Product & E-commerce Videos",
        description:
            "Showcase products with clean, appealing edits for online stores and social media. I highlight key features, arrange footage into a clear flow, add suitable music, text, and graphics, and polish the color and sound.",
    },
    {
        title: "Promotional & Brand Videos",
        description:
            "Create concise promotional edits for a brand, service, or campaign. I bring footage, messaging, music, and graphics together in a style that fits your audience and the platform where it will appear.",
    },
    {
        title: "Motion Graphics & Video Enhancement",
        description:
            "Add titles, captions, lower thirds, transitions, and simple motion graphics to make information easier to follow and give your video a more finished look. Includes audio balancing and color refinement.",
    },
];
const experience = [
    {
        title: "Freelance Video Editor | Fiverr (December 2024 to Present)",
        description1: "Create and edit video content for software products and e-commerce brands, using AI-assisted tools where they support the creative workflow.",
        description2: "Shape raw footage into polished videos with purposeful cuts, pacing, transitions, music, sound adjustments, and color correction.",
        description3: "Adapt edits, layouts, captions, and visual style to the content goal, target audience, and platform.",
    },
    {
        title: "Motion Graphics Designer | Bold Stream Production (January 2023 to December 2024)",
        description1: "Designed and added motion graphics, animated titles, captions, and visual elements to video projects.",
        description2: "Used graphics, transitions, and layout choices to clarify information and strengthen each video's visual flow.",
        description3: "Worked with video edits to keep graphics consistent with the content style, pacing, and intended audience.",
    },
    {
        title: "Social Media Video Editor | Cineviz Studio (April 2023 to September 2023)",
        description1: "Edited social media videos into engaging, platform-appropriate content, including short-form formats.",
        description2: "Selected strong moments and refined cuts, pacing, music, sound, and color to hold viewers' attention.",
        description3: "Prepared clear, visually polished edits with suitable text, transitions, and layouts for each video's purpose.",
    },
];
const dataportfolio = [
    { category: "ai-video", title: "Instagram AI Ad", videoUrl: "https://specarttechnologies.com/videos/AI/INSTAMALL_AI.mp4" },
    { category: "ai-video", title: "Jaywalking Awareness", videoUrl: "https://specarttechnologies.com/videos/AI/JAYWALKING.mp4" },
    { category: "ai-video", title: "AI Commerce Ad", videoUrl: "https://specarttechnologies.com/videos/AI/AI%20commercial.mp4" },
    { category: "ai-video", title: "AI Room Decor Showcase", videoUrl: "https://specarttechnologies.com/videos/AI/AI%20Home%20Decor.mp4" },
];
const shortformportfolio = [
    { title: "We Are Uprisers", videoUrl: "https://specarttechnologies.com/videos/Short%20Form/weareuprisers.mp4" },
    { title: "Eric Layden", videoUrl: "https://specarttechnologies.com/videos/Short%20Form/EricLayden.mp4" },
    { title: "Solarin", videoUrl: "https://specarttechnologies.com/videos/Short%20Form/SolarinOneMinute.mp4" },
    { title: "Type of Timing", videoUrl: "https://specarttechnologies.com/videos/Short%20Form/TypeofTiming.mp4" },
];
const animationportfolio = [
    { title: "What Is Notion", videoUrl: "https://specarttechnologies.com/videos/2D%20animation/WhatisNotion.mp4" },
    { title: "Ascent", videoUrl: "https://specarttechnologies.com/videos/2D%20animation/Ascent%20.mp4" },
    { title: "McDonald's Promo", videoUrl: "https://specarttechnologies.com/videos/2D%20animation/Mcdonalds.mp4" },
    { title: "Motorbike Campaign", videoUrl: "https://specarttechnologies.com/videos/2D%20animation/Mobike.mp4" },
];
// real projects to be added here later
const blockchainprojects = [];

const contactConfig = {
    YOUR_EMAIL: "hamzaruell@gmail.com",
    YOUR_FONE: "+92-321-4880643",
    YOUR_LOCATION: "Available Remotely",
    description: "Need a YouTube video, vlog, Reel, Short, product video, or animation edited? Get in touch by email, phone, or the form to discuss your project. Let’s create a video your audience will remember.",
    // creat an emailjs.com account
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_s4artfi",
    YOUR_TEMPLATE_ID: "template_h9qpawm",
    YOUR_USER_ID: "ERkJ13FM6ITez2y1i",
};

const socialprofils = {
    facebook: "https://web.facebook.com/hamzaruel96",
    twitter: "https://x.com/Hamza55138992",
};
export {
    meta,
    dataabout,
    aboutstats,
    dataportfolio,
    shortformportfolio,
    animationportfolio,
    blockchainprojects,
    worktimeline,
    skills,
    services,
    introdata,
    experience,
    contactConfig,
    socialprofils,
    logotext,
};
